import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import { BsModalRef } from 'ngx-bootstrap';
import { ReservationStatus } from 'src/app/models/reservation-status';
import { AppAttributesService } from 'src/app/services/app-attributes.service';
import { Contract } from 'src/app/models/contract';
import  *  as moment from 'moment';
import { ArService } from 'src/app/services/ar.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-service-add-dialog',
  templateUrl: './service-add-dialog.component.html',
  styleUrls: ['./service-add-dialog.component.scss']
})
export class ServiceAddDialogComponent implements OnInit {
  @Input() reservation: any
  stationId: string;
  flightDate :string;
  services_form: FormGroup;
  reservationStatusList: ReservationStatus[];
  serviceList: any[] = [];
  contractList: any[] = [];
  resType: string = 'retail';
  submitted = false
  contracts: Contract[] = [];
  services: any[] = [];
  reservationId;
  public get s() { return this.services_form.controls; }

  public event: EventEmitter<any> = new EventEmitter();

  constructor(public bsModalRef: BsModalRef,private formBuilder: FormBuilder,  private spinner: NgxSpinnerService,
    private notifier: NotifierService,  private arService: ArService,
    private appAttrService: AppAttributesService) { }

  ngOnInit() {

    // console.log(this.reservation);

    this.stationId  = this.reservation[0].STATION;
    this.resType = this.reservation[0].RES_TYPE;
    this.reservationId  = this.reservation[0].RESID;
    this.getContractsId(this.resType, this.stationId);
    

    this.appAttrService.getflightDate().subscribe(async fdate=>{
      this.flightDate = fdate;
    })
    this.services_form = this.formBuilder.group({
      contractId: ['', [Validators.required]],
      quantity: ['', [Validators.required]],
      service: ['', [Validators.required]],
      serviceNotes: [''],
      amount: new FormControl(''),
      discount:[''],
      actual_amount :[0],
      contract_type:['']
    });
  }




  getContractType() {
    let service = this.serviceList.filter(res =>
      res.ContractServicesID == this.services_form.controls.service.value);
    return service.length === 0 ? '' : service[0].ShortDesc;
  }

  getServices(station) {
    this.serviceList = [];
    // this.contractList = [];
    this.appAttrService.getServicesByStation(station).subscribe((res: any) => {
      if (res.status) {
        this.serviceList = res.result;
        this.getContractsId(this.resType, station).then(ressss => {
         // console.log(ressss);
        })

        // this.contractList = res.result;
      }
    }, error => {
      console.log(error);
    })
  }
  validation_messages = {
    'quantity': [
      { type: 'required', message: 'Quantity required.' },
    ],
    'service': [
      { type: 'required', message: 'Service required.' },
    ],
    'amount': [
      { type: 'required', message: 'Unit Charge required.' }
    ]
  }

  totalServiceAmount = 0 ;
  serviceUnitCharge = 0;
  onServiceAmount(quantity){
    // console.log(quantity)
    let service = this.serviceList.filter(res =>
      res.ContractServicesID == this.services_form.controls.service.value)[0];
      // console.log(service)
   let  amount =  service.ShortDesc === 'MiscService' ? this.services_form.controls.amount.value : service.Amount;
  //  console.log(amount);
   this.serviceUnitCharge = amount;
  //  console.log(this.serviceUnitCharge)
   if(quantity.value){
    // console.log(quantity.value)
    this.totalServiceAmount = amount*quantity.value;
    // console.log(this.totalServiceAmount)
   }
  }

  onServiceChange(contractServicesId) {
      //  console.log(this.getContractType());
      if (this.getContractType() === 'MiscService') {
        this.services_form.get('amount').setValidators([Validators.required]);
        this.services_form.get('amount').updateValueAndValidity();
      } else {
        this.services_form.get('amount').setValidators(null);
        this.services_form.get('amount').updateValueAndValidity();
      }
      const serviceSelected = this.getServiceLineBy(contractServicesId);
     console.log(serviceSelected[0]);
      this.totalServiceAmount = serviceSelected[0].Amount;
      this.serviceUnitCharge = serviceSelected[0].Amount;
      this.totalServiceAmount = serviceSelected[0].Amount;
      let actualAmount = serviceSelected[0].ACTUAL_AMOUNT;
      let discountPer = serviceSelected[0].DISCOUNT_PERCENTAGE;
      let serviceName = serviceSelected[0].ContractID;
      this.services_form.get('actual_amount').setValue(actualAmount);
      this.services_form.get('actual_amount').updateValueAndValidity();
      this.services_form.get('discount').setValue(discountPer);
      this.services_form.get('discount').updateValueAndValidity();
      this.services_form.get('contract_type').setValue(serviceName);
      this.services_form.get('contract_type').updateValueAndValidity();
    }

    getServiceLineBy(ContractServicesID){
      return this.serviceList.filter(value => value.ContractServicesID == ContractServicesID);
    }


  async getContractsId(resType, station) {
    // console.log(resType, station);
     await this.appAttrService.getContractsIdStation(resType, station).subscribe((res: any) => {
      // console.log(res);
       if (res.status) {
         this.contractList = res.result;
       }
     }, error => {
       console.log(error);
     })
   }


  addService() {

    this.submitted = true
    this.services_form.markAllAsTouched();
    let service = this.serviceList.filter(res =>
      res.ContractServicesID == this.services_form.controls.service.value)[0];

    if (!this.services_form.controls.quantity.value || !this.services_form.controls.service.value) {
      return;
    }
    if(this.services_form.invalid){
      return
    }

    if (this.getContractType() === "MiscService" && this.services_form.controls.amount.value == 0) {

      this.notifier.notify('warning', 'Please enter Unit Charge')
      return;
    }

    let amount = service.ShortDesc === 'MiscService' ? this.services_form.controls.amount.value : service.Amount
    // console.log('serviceForm:-',this.services_form);
    let actual ;
    let dis;
     if(this.services_form.controls.discount.value){
      dis = this.services_form.controls.discount.value
     }else{
      dis = 0
     }
     if(this.services_form.controls.actual_amount.value){
      actual = this.services_form.controls.actual_amount.value
     }else{
      actual = amount
     }
    let serviceInfo = {
      resId : this.reservationId,
      lcbId: 15,
      quantity: this.services_form.controls.quantity.value,
      contractServiceId: service.ContractServicesID,
      miscDescription: service.LongDesc,
      amount: parseFloat(amount).toFixed(2),
      slNotes: this.services_form.controls.serviceNotes.value,
      active: 1,
      DISCOUNT:dis,
      ACTUAL_AMOUNT :actual,
      SERVICE_NAME:this.services_form.controls.contract_type.value
    }
    // console.log(serviceInfo);
    this.services.push(serviceInfo);
    // this.submitted = false
    // this.services_form.markAsUntouched()
    // this.services_form.controls.quantity.reset()
    // this.services_form.controls.service.reset()
    // this.services_form.controls.amount.reset()
    // this.services_form.controls.serviceNotes.reset();
    // this.services_form.controls.quantity.setValue(null);
    // this.services_form.controls.service.setValue(null);
    // this.services_form.controls.amount.setValue(null);
    // this.services_form.controls.serviceNotes.setValue(null);
    //this.notifier.notify('success', 'Service details added successfully');
    // window.scrollTo(0, document.body.scrollHeight);
    //console.log(this.services); 
    this.spinner.show();
      this.arService.addAdditionalService(this.services).subscribe(res=>{
        this.spinner.hide();
        if (res['status']) {
          this.notifier.notify('success', 'Service added successfully.')
          this.bsModalRef.hide();
          this.triggerEvent(true);
        } else {
          this.notifier.notify('danger', res['message'])
          this.bsModalRef.hide();
          this.triggerEvent(false);
        }
        // console.log(res);
      },error=>console.log('error:',error));

  }

  getServicesByContractId(cid) {
    this.getContractDetailsById(cid, this.stationId);
  }

getContractDetailsById(contract, station) {
    this.serviceList  = [];
    this.serviceUnitCharge =0;
    this.totalServiceAmount = 0;

    this.services_form.get('service').setValue('');
    this.services_form.get('service').updateValueAndValidity();

    this.services_form.get('quantity').setValue('');
    this.services_form.get('quantity').updateValueAndValidity();
    // console.log('Getting Contract Details ServiceLine ', contract, station ,this.flightDate);
     let csdate = moment(this.flightDate).format('YYYY-MM-DD');
     let contractType = this.resType;
     this.appAttrService.getContractServiceDetailsByDate(contractType,contract, station,csdate).subscribe((res: any) => {
       if (res.status) {
         this.serviceList = res.result;
          // console.log(this.serviceList);
       }
     }, error => {
       console.log(error);
     })
     // this.appAttrService.getContractDetailsById(contract, station).subscribe((res: any) => {
     //   if (res.status) {
     //     this.serviceList = res.result;
     //      console.log(this.serviceList);
     //   }
     // }, error => {
     //   console.log(error);
     // });
}

  triggerEvent(data) {
    this.event.emit({ data: data, res: 200 });
  }

  closeModal() {
    this.bsModalRef.hide();
    this.triggerEvent(null)
  }
}
